import type { FaireProductEntity } from "../../entity_types/product";

export const p_dt4aqsdrec: FaireProductEntity = {
  token: "p_dt4aqsdrec",
  type: "product",
  name: "Bewater Love Harmony - Rose Quartz and Clear Quartz Crystal",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3957c976b11813d7063ffdcb5cab3a5b4b555b12c6ee27ef236eb3bf101b7f2f.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e62c6369f79f140a416eb1fb0ae5484cf1a272b9943c1d472e4341b22ce889e9.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
